module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-14.e64180a8.png";